module.exports = __webpack_public_path__ + "img/spc-sidebar-desktop.f04b82c.png";